import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import api from "../../lib/api";

export default function AdminIscritti() {
  const [iscritti, setIscritti] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    const t = setTimeout(() => {
      api.get("/admin/iscritti", { params: q ? { q } : {} }).then((res) => setIscritti(res.data)).catch(() => {});
    }, 300);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8" data-testid="admin-iscritti-page">
      <h1 className="font-heading text-3xl font-bold text-bordeaux-dark">Iscritti</h1>

      <div className="relative mt-6 max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <input
          data-testid="admin-iscritti-search"
          className="input-elegant !pl-9"
          placeholder="Cerca per nome, email o codice fiscale..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <div className="card-elegant mt-6 overflow-x-auto !p-0">
        <table className="w-full min-w-[720px] text-sm" data-testid="admin-iscritti-table">
          <thead>
            <tr className="border-b border-border bg-bordeaux-ultralight text-left text-xs uppercase tracking-wider text-bordeaux-dark">
              <th className="px-5 py-3">Nome</th>
              <th className="px-5 py-3">Cognome</th>
              <th className="px-5 py-3">Email</th>
              <th className="px-5 py-3">Codice Fiscale</th>
              <th className="px-5 py-3">Data iscrizione</th>
              <th className="px-5 py-3">Richieste</th>
              <th className="px-5 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {iscritti.length === 0 && (
              <tr><td colSpan={7} className="px-5 py-8 text-center text-muted-foreground" data-testid="admin-iscritti-empty">Nessun iscritto trovato.</td></tr>
            )}
            {iscritti.map((u) => (
              <tr key={u.id} className="border-b border-border last:border-0 hover:bg-muted/50" data-testid={`admin-iscritto-row-${u.codice_fiscale}`}>
                <td className="px-5 py-3 font-medium">{u.nome}</td>
                <td className="px-5 py-3 font-medium">{u.cognome}</td>
                <td className="px-5 py-3">{u.email}</td>
                <td className="px-5 py-3 tracking-wider">{u.codice_fiscale}</td>
                <td className="px-5 py-3">{new Date(u.created_at).toLocaleDateString("it-IT")}</td>
                <td className="px-5 py-3 font-semibold text-bordeaux">{u.numero_richieste}</td>
                <td className="px-5 py-3">
                  <Link to={`/admin/iscritti/${u.id}`} data-testid={`admin-iscritto-open-${u.codice_fiscale}`} className="font-semibold text-bordeaux hover:underline">
                    Apri
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
